import React from 'react'

export function cancel() {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20" style={{enableBackground:"new 0 0 20 20"}} xmlSpace="preserve">
      <path className="stroke" d="M18 18L2.507 2M3.014 18L18.507 2"/>
    </svg>
  )
}
